<template>
    <transition name="bmv-loader-fade">
        <div
            v-if="shown"
            class="bmv-loader"
            :class="{ 'bmv-loader--fullpage': fullPage, 'bmv-loader--inline': !fullPage }"
            role="status"
            aria-live="polite"
        >
            <div class="bmv-loader-spinner" aria-hidden="true"></div>
            <span v-if="label" class="bmv-loader-label">{{ label }}</span>
        </div>
    </transition>
</template>

<script>
/**
 * SPDX-FileCopyrightText: © 2021-2026 SAS Cœur du Web, Paris (France) — https://coeurduweb.com
 * SPDX-License-Identifier: LicenseRef-CoeurDuWeb-Proprietary
 *
 * Tous droits réservés. Logiciel propriétaire, non libre.
 * Les conditions d'utilisation, le périmètre de la licence concédée et les
 * restrictions applicables figurent dans le fichier LICENCE.md à la racine du dépôt.
 */
export default {
    name: 'BmvLoader',
    model: {
        prop: 'value',
        event: 'input'
    },
    props: {
        value: { type: Boolean, default: undefined },
        active: { type: Boolean, default: false },
        fullPage: { type: Boolean, default: false },
        label: { type: String, default: '' }
    },
    computed: {
        shown() {
            return this.value !== undefined ? this.value : this.active
        }
    }
}
</script>

<style scoped>
.bmv-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 12px;
    z-index: 100;
}

.bmv-loader--fullpage {
    position: fixed;
    inset: 0;
    background: rgba(15, 23, 42, 0.45);
    z-index: 1200;
    backdrop-filter: blur(2px);
}

.bmv-loader--inline {
    position: absolute;
    inset: 0;
    background: rgba(255, 255, 255, 0.75);
}

.bmv-loader-spinner {
    width: 36px;
    height: 36px;
    border-radius: 50%;
    border: 3px solid rgba(8, 145, 178, 0.2);
    border-top-color: var(--v2-primary);
    animation: bmv-loader-spin 800ms linear infinite;
}

.bmv-loader--fullpage .bmv-loader-spinner {
    width: 44px;
    height: 44px;
    border-width: 4px;
    border-color: rgba(255, 255, 255, 0.25);
    border-top-color: #fff;
}

.bmv-loader-label {
    font-family: var(--v2-font-sans);
    font-size: var(--v2-text-sm-size);
    font-weight: var(--v2-font-weight-semibold);
    color: var(--v2-text-2);
}

.bmv-loader--fullpage .bmv-loader-label {
    color: #fff;
}

.bmv-loader-fade-enter-active,
.bmv-loader-fade-leave-active {
    transition: opacity 160ms ease;
}

.bmv-loader-fade-enter,
.bmv-loader-fade-leave-to {
    opacity: 0;
}

@keyframes bmv-loader-spin {
    to { transform: rotate(360deg); }
}
</style>
